import { Flex, Grid, GridItem } from '@chakra-ui/react';
import Balance from 'views/admin/dashboards/default/components/Balance';
import OverallRevenue from 'views/admin/dashboards/default/components/OverallRevenue';
import StatsBar from 'views/admin/dashboards/default/components/StatsBar';
import YourCard from 'views/admin/dashboards/default/components/YourCard';
import MapCard from 'views/admin/dashboards/smartHome/components/MapCard';

export default function Default() {
  return (
    <Flex direction="column" pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <StatsBar />

      <Grid
        mb="20px"
        templateColumns={{ base: '1fr', xl: 'minmax(0, 1.45fr) minmax(340px, 1fr)' }}
        templateRows={{ base: 'auto', xl: 'auto auto' }}
        gap="20px"
        alignItems="stretch"
      >
        <GridItem rowSpan={{ base: 1, xl: 2 }}>
          <MapCard h="100%" />
        </GridItem>
        <GridItem>
          <OverallRevenue />
        </GridItem>
        <GridItem>
          <YourCard />
        </GridItem>
      </Grid>

      <Balance />
    </Flex>
  );
}
